<template>
    <!DOCTYPE html><html>
      <head></head>
        <body style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">
          <pre style="padding-bottom: 8px; font-family: 'Montserrat', sans-serif; font-size: 34px; font-weight:900; text-align: center; text-transform: uppercase;">Movimiento de caja: {{movimiento.id}}</pre>
          <table style="border-collapse: collapse; width: 100%; font-size: 32px; text-align: left;">  
            <tr>    
              <th style="padding: 2px; text-align: left; background-color: white;"></th> 
              <th style="padding: 2px; text-align: left; background-color: white;"></th>  
            </tr> 
            <tr>    
              <td style="padding: 2px; font-weight:600;">TIPO:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{tipo}}</td>  
            </tr>   
            <tr>    
              <td style="padding: 2px; font-weight:600;">MONTO:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">${{movimiento.monto}}</td>  
            </tr>   
            <tr>    
              <td style="padding: 2px; font-weight:600;">MOTIVO:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{movimiento.motivo}}</td>  
            </tr>
            <tr>    
              <td style="padding: 2px; font-weight:600;">DETALLES:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{movimiento.detalles}}</td>  
            </tr>
            <tr v-if="tipo == 'egreso'">    
              <td style="padding: 2px; font-weight:600;">AGENCIA:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{ user.agencia_activa }}</td>   
            </tr>
            <tr>    
              <td style="padding: 2px; font-weight:600;">FECHA:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{movimiento.created_at | moment('DD-MM-YYYY')}}</td>   
            </tr>
            <tr>    
              <td style="padding: 2px; font-weight:600;">HORA:</td>
              <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{movimiento.created_at | moment('hh:mm:ss')}}</td>   
            </tr>
            <!--
            <tr v-if="movimiento.resumen_pago != undefined">    
                <td style="padding: 2px; font-weight:600;"></td> 
                <td style="padding: 2px; text-transform: uppercase; font-weight:800;">{{movimiento.resumen_pago}}</td> 
            </tr>
            -->   
          </table>
          <p style="align:center; border-collapse: collapse; width: 100%; font-size: 28px; padding: 2px;"><span style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">NOMBRE Y FIRMA DE QUIEN ENTREGA:</span> _________________________________</p>
          <p style="align:center; border-collapse: collapse; width: 100%; font-size: 28px; padding: 2px;"><span style="font-family: 'Montserrat', sans-serif; color: #000000 !important;">NOMBRE Y FIRMA DE QUIEN RECIBE:</span> _________________________________</p>
          <p style="margin-top: 20px; margin-bottom: 0px; font-family: 'Montserrat', sans-serif; font-size: 20px; font-weight:600; text-align: left; text-transform: uppercase">
            {{user.username}}/{{movimiento.created_at | moment('DDMMYYYY')}}/{{ movimiento.created_at | moment('HH:mm') }} 
          </p>
        </body>
      </html>
</template>
<script>
export default {
  props: {
    movimiento: {required: false},
    tipo: {required: false},
    user: {required: false}
  },

  data() {
      return {
       
      };
    },

  mounted(){
    //const date = new Date();
    //this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
  },
}
</script>
<style scoped> 
</style>